<h2>共通重要事項</h2>
<div class="body">
    <div>
        重要事項説明 共通事項QRコード
    </div>
    <div fxflex>
        <qrcode *ngIf="importantItemUrl" [qrdata]="importantItemUrl" [errorCorrectionLevel]="'M'"></qrcode>
    </div>
    <div>
        重要事項説明 共通事項 は
        <a [href]= "importantItemUrl" target="_blank">
            こちら
        </a>
    </div>
</div>